export const IS_MORE_TOOLS_FORM_SUBMITTED = "IS_MORE_TOOLS_FORM_SUBMITTED";
export const SET_MORE_TOOLS_FORM_IS_SUBMITTED =
  "SET_MORE_TOOLS_FORM_IS_SUBMITTED";
